import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnon = process.env.REACT_APP_SUPABASE_ANON_KEY;

// CRA inlines REACT_APP_* at build time. If they were missing when the site was built,
// createClient would throw on import and the page would render blank; App shows a config error instead.
export const missingConfig = [
  !supabaseUrl  && 'REACT_APP_SUPABASE_URL',
  !supabaseAnon && 'REACT_APP_SUPABASE_ANON_KEY',
].filter(Boolean);

export const supabase = missingConfig.length ? null : createClient(supabaseUrl, supabaseAnon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
